// extracted by mini-css-extract-plugin
export var active = "_e9-7";
export var container = "_e9-0";
export var evenWidth = "_e9-4";
export var large = "_e9-5";
export var outlet = "_e9-8";
export var slide = "_e9-2";
export var small = "_e9-6";
export var tab = "_e9-3";
export var tabs = "_e9-1";